<div class="logout-container">
  <div>
    <div class="form-card flex-row left">
      <ng-container>
        <div class="form-card-body background-secondary">
          <div>You are logged out...</div>
          <div>Redirecting to Login in ({{ seconds }}) seconds...</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
